module.exports = __webpack_public_path__ + "static/media/Guyana - GY.8b9bcfff.png";